import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

export const namespace = "fnLayout";

export const layoutStore = (action) => {
    return namespace + "/" + action;
};

export const store_ = {
    namespaced: true,
    state: {
        columns: []
    },
    getters,
    mutations,
    actions
};

export default {
    /**
     * Install the layout store into the app store
     *
     * @param store {{registerModule: function(string,Object)}}
     */
    install: function(store){
        store.registerModule(namespace, store_);
    }
};
